/* 94 Origin — Ajax quick-add (R9). Intercepts forms marked [data-origin-add],
   adds via /cart/add.js with Section Rendering of Horizon's cart-drawer-section,
   swaps the drawer HTML, updates the count, and opens the native drawer. */
(function () {
  var DRAWER_SECTION = 'cart-drawer-section';
  var DRAWER_DOM_ID = 'shopify-section-' + DRAWER_SECTION;

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function swapDrawer(html) {
    if (!html) return;
    var current = document.getElementById(DRAWER_DOM_ID);
    if (!current) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById(DRAWER_DOM_ID) || doc.body.firstElementChild;
    if (fresh) current.replaceWith(fresh);
  }

  function openDrawer() {
    // <theme-drawer id="cart-drawer"> exposes open()/close()/toggle(). Call open() directly —
    // clicking the cart pill would follow its <a href="/cart"> and navigate away instead.
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    if (typeof drawer.open === 'function') { drawer.open(); return; }
    var dialog = drawer.querySelector('dialog');
    if (dialog && dialog.showModal && !dialog.open) dialog.showModal();
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-origin-add], form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var fd = new FormData(form);
    fd.append('sections', DRAWER_SECTION);
    fd.append('sections_url', window.location.pathname);
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }

    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw res.d;
        swapDrawer(res.d.sections && res.d.sections[DRAWER_SECTION]);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) { updateCount(cart.item_count); openDrawer(); })
      .catch(function () { form.submit(); /* fall back to full-page add */ })
      .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
  });
})();
